@if (breadcrumbs()?.length) {
    <companyid-divider-img />
    <companyid-content-wrapper classNames="items-center w-full mob:px-5 tab:px-5 h-30px">
        <div class="flex gap-3 text-dark-6 text-extra-small-regular py-5px">
            @for (breadcrumb of breadcrumbs(); track breadcrumb.label; let last = $last) {
                @if (!last) {
                    <a [routerLink]="breadcrumb.url" class="flex cursor-pointer gap-x-3">
                        @if (breadcrumb.label === 'Home') {
                            <img
                                [ngSrc]="'home' | asset: 'shared/breadcrumbs'"
                                width="14"
                                height="15"
                                alt="home" />
                        }
                        {{ breadcrumb.label }} <span>>&nbsp;</span></a
                    >
                }
                @if (last) {
                    <span class="text-dark"> {{ breadcrumb.label }}</span>
                }
            }
        </div>
    </companyid-content-wrapper>
}
